export default "__VITE_ASSET__Cu04Fvt6__"